export default __webpack_public_path__ + "about-us-section.png";